import React from "react";
import "./bodyCardEvent.sass";

export default function Team({ imgTeam, altTeam, nameTeam, momioTeam, pointsTeam, isMiddle, urlMomio, urlEvento, classTeam, flagMomios, classGame }) {

    // "clarosports-winner" // ganador
    // "clarosports-loser" // perdedor
    let classNextGame = "clarosports-next-game";
    let classErrorGame = "clarosports-error-game";

    return (
        <div className={isMiddle ? "container-team container-team-middle" : "container-team"}>
            {String(urlEvento).length > 0 ? (
                <a className="team-img-name" href={urlEvento} target="_top">
                    {!isMiddle && (
                        <>
                            <img className="team-img" alt={altTeam} src={imgTeam} loading="lazy" />
                            <p className="team-name">{nameTeam}</p>
                        </>
                    )}
                </a>
            ) : (
                <div className="team-img-name no-click">
                    {!isMiddle && (
                        <>
                            <img className="team-img" alt={altTeam} src={imgTeam} loading="lazy" />
                            <p className="team-name">{nameTeam}</p>
                        </>
                    )}
                </div>
            )}

            {(String(classGame).toLowerCase() !== classNextGame && String(classGame).toLowerCase() !== classErrorGame) ?
                String(urlEvento).length > 0
                    ?
                    <a className={flagMomios === "true" && (classGame !== "clarosports-finished-game" && classGame !== "clarosports-error-game") ? "team-score min" : "team-score full"} href={urlEvento} target="_top">
                        {!isMiddle &&
                            <p className={classTeam}>{pointsTeam}</p>
                        }
                    </a>
                    :
                    <p className={flagMomios === "true" && (classGame !== "clarosports-finished-game" && classGame !== "clarosports-error-game") ? "team-score min" : "team-score full"}>
                        {!isMiddle &&
                            <span className={classTeam}>{pointsTeam}</span>
                        }
                    </p>
                : null
            }

            {flagMomios === "true" && (classGame !== "clarosports-finished-game" && classGame !== "clarosports-error-game") &&
                String(urlMomio).length > 0
                ?
                <a className="team-momio" href={urlMomio} target="_blank" rel="noreferrer">
                    <p>{momioTeam}</p>
                </a>
                :
                <p className="team-momio">
                    <span>{momioTeam}</span>
                </p>
            }
        </div>
    );
}
